module.exports = __webpack_public_path__ + "static/media/gruporv-solution-seguros-grey.318937bb.svg";